var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"wrapper"},[(!_vm.clientSettings)?_c('h1',[_vm._v("Not Found")]):_c('h1',[_vm._v("This portal is currently offline")])])
}
var staticRenderFns = []

export { render, staticRenderFns }